<template>
  <b-container>
<div
  class="fixed-center d-flex align-items-center justify-content-center"
  style="bottom: 0; overflow-y: auto"
>


        <b-card
          title="Request More Information"
        style="width: 30rem"
        >
            <p>Thank you for your interest, please fill out the form below and someone will reach out to you with demo credentials.
            </p>
            <b-alert show variant="danger" v-if="errorLogin">{{errorAlert}}</b-alert>
            <b-form @submit="onSubmit">
              <b-form-row>
                <b-col>
                <b-form-group
                  id="wardName"
                  label="Ward Name"
                  label-for="wardName"
                  >
                  <b-form-input
                    id="wardName"
                    v-model="moreInfoRequest.ward_name"
                    type="text"
                    placeholder="You Ward Name"
                    hint="The full ward name."
                    required>
                  </b-form-input>
                </b-form-group>
                </b-col>
                <b-col>
                <b-form-group
                  id="wardName"
                  label="Ward City and State"
                  label-for="wardCity"
                  >
                  <b-form-input
                    id="warName"
                    v-model="moreInfoRequest.ward_city"
                    type="text"
                    placeholder="You Ward City and State"
                    required>
                  </b-form-input>
                </b-form-group>
</b-col>
                </b-form-row>
              <b-form-row>
                <b-col>
                <b-form-group
                  id="stakeName"
                  label="Stake Name"
                  label-for="stakeName"
                  >
                  <b-form-input
                    id="stakeName"
                    v-model="moreInfoRequest.stake_name"
                    type="text"
                    placeholder="You Stake Name"
                    required>
                  </b-form-input>
                </b-form-group>
                  </b-col>
                <b-col>
                <b-form-group
                  id="stakeCity"
                  label="Stake City and State"
                  label-for="stakeCity"
                  >
                  <b-form-input
                    id="stakeCity"
                    v-model="moreInfoRequest.stake_city"
                    type="text"
                    placeholder="You Stake City and State"
                    required>
                  </b-form-input>
                </b-form-group>
                  </b-col>
</b-form-row>
              <b-form-row>
                <b-col>

                <b-form-group
                  id="fullName"
                  label="Full Name"
                  label-for="fullName"
                  >
                  <b-form-input
                    id="fullName"
                    v-model="moreInfoRequest.full_name"
                    type="text"
                    placeholder="Full Name"
                    required>
                  </b-form-input>
                </b-form-group>
                </b-col>
                </b-form-row>
              <b-form-row>
                <b-col>
                <b-form-group
                  id="email"
                  label="Contact Email"
                  label-for="email"
                  >
                  <b-form-input
                    id="email"
                    v-model="moreInfoRequest.email"
                    type="email"
                    placeholder="you@someone.com"
                    required>
                  </b-form-input>
                </b-form-group>
                </b-col>
                <b-col>
                <b-form-group
                  id="phone"
                  label="Contact Phone"
                  label-for="phone"
                  required
                  description="For a more prompt response please include phone number where to contact"
                  >
                  <b-form-input
                    id="phone"
                    v-model="moreInfoRequest.contact_phone"
                    type="phone"
                    placeholder="1239991234">
                  </b-form-input>
                </b-form-group>
                </b-col>
              </b-form-row>
                <b-form-group
                    id="input-group-4"
                    label="Additional Note/Comment:"
                    label-for="input-4"
                    description="Brief description if you ready to use or just want a demo to the app.">
                    <b-form-textarea
                      id="textarea"
                      v-model="moreInfoRequest.message"
                      placeholder="I'm ready to start using!"
                      rows="4"
                      max-rows="4"
                      required
                    ></b-form-textarea>
                </b-form-group>
                <b-button
                    type="submit"
                    pill variant="success"
                    align="center"
                    :disabled="show">
                <b-spinner small v-if="show"></b-spinner>
            {{submitText}}</b-button>
            </b-form>
        </b-card>
</div>
    </b-container>
</template>
<script>
import { MoreInfoApi } from "@/api/moreInfoApi";
export default {
  name: 'Contact',
  data () {
      return {
          moreInfoRequest: {
            ward_name: null,
            ward_city: null,
            stake_name: null,
            stake_city: null,
            full_name : null,
            email: null,
            message: null,
            contact_phone: null
          },
          errorAlert:null,
          errorLogin:false,
          show:false,
          items: [
            {
              text: 'Home',
              to: { name: 'home' },
              active: false,
            },
            {
              text: 'More Info',
              active: true
            }
          ]
      }
  },
  computed: {
      submitText () {
          if(!this.show) {
              return "Request Information";
          }
          return "Sending...";
      }
  },
  mounted() {
  },
  methods: {
      async onSubmit (event) {
          event.preventDefault();
          try{
            this.show = true;
            const { data } = await MoreInfoApi.requestMoreInfo(this.moreInfoRequest);
            this.$toast.success("Successfully sent request for information, please allow time to process your request!");
            this.$router.push({ name: 'home'});

          }catch(error){
              console.log(error);
              this.errorAlert = error.response.data.detail;
              this.errorLogin = true;
          }finally{
              this.show = false;
          }
      }
  }
}
</script>
